export const PROJECT_ID_STORAGE_KEY = "myiko_project_id"

const PROJECT_ID_PATTERN = /^[A-Za-z0-9_-]{1,100}$/

export const isValidProjectId = (
  value: string | null | undefined
): value is string =>
  typeof value === "string" && PROJECT_ID_PATTERN.test(value.trim())

/**
 * Read project_id from a query string, validate it, and persist it to
 * sessionStorage for the duration of the tab session. Never clears an existing
 * value. Returns the validated value, or null when absent/invalid.
 */
export const captureProjectIdFromUrl = (
  search: string = window.location.search
): string | null => {
  const raw = new URLSearchParams(search).get("project_id")
  const value = raw?.trim() ?? null
  if (!isValidProjectId(value)) return null
  try {
    window.sessionStorage.setItem(PROJECT_ID_STORAGE_KEY, value)
  } catch {
    // sessionStorage may be unavailable; value is still returned for this load
  }
  return value
}
